module.exports = __webpack_public_path__ + "static/img/icon_baby_boy.9090ee62.png";